import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import reducerPath from '../../../app/reducerPath';
import { subscribeSensors, unsubscribeSensors } from '../../../shared/api/sensorSubscribtion';

const normalizeMessage = (message) => {
  if (!message?.data) return [];

  const sendTime = message.sendTime || null;

  return Object.entries(message.data).map(([sensorId, [value]]) => ({
    sensorId: Number(sensorId),
    value,
    sendTime,
  }));
};

export const sensorLiveValuesApi = createApi({
  reducerPath: `${reducerPath.sensorLiveValues}/api`,
  baseQuery: fakeBaseQuery(),
  tagTypes: ['SENSOR'],
  endpoints: (builder) => {
    return {
      getVehicleSensorsLive: builder.query({
        queryFn: () => ({ data: { data: [] } }),
        keepUnusedDataFor: 0,

        async onCacheEntryAdded({ vehicleIds, sensorIds }, { cacheDataLoaded, cacheEntryRemoved, updateCachedData }) {
          await cacheDataLoaded;

          await subscribeSensors({ vehicleIds, sensorIds }, (message) => {
            const data = normalizeMessage(message);

            updateCachedData((draft) => {
              data.forEach((incoming) => {
                const existing = draft.data.find((s) => s.sensorId === incoming.sensorId);

                if (existing) {
                  existing.value = incoming.value;
                  existing.sendTime = incoming.sendTime;
                } else {
                  draft.data.push(incoming);
                }
              });
            });
          });

          await cacheEntryRemoved;
          unsubscribeSensors();
        },
      }),
    };
  },
});

export const { useGetVehicleSensorsLiveQuery } = sensorLiveValuesApi;
